import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --top-bar-background-color: #003a70;
    --primary-color-dark: #063a93;
    --primary-color: #063a93;
    --primary-color-light: #3742fa;
    --primary-color-ascent: #0075ff;
    --secondary-color: #d82530;
    --secondary-color-light: #f62a36;
    --secondary-color-dark: #af202b;
    --text-font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    --title-font-family: "Segoe UI", sans-serif;
    --title-font-weigth: 700;
    --background-color: #fff;
    --content-background-color: #fff;
  }

  ::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .2) !important;
  }

  ::-webkit-scrollbar-track {
    background: hsla(0, 0%, 100%, .08) !important;
  }

  html {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  body {
    background-color: #fff !important;
    -webkit-overflow-scrolling: touch;
    height: initial !important;
    background: var(--background-color) !important;
  }

  html,
  body,
  div,
  p {
    color: #323232;
    font-size: 15px;
    font-family: var(--text-font-family);

    @media (max-width: 800px) {
      font-size: 14px;
    }
  }

  #root {
    position: relative;
    display: block;
    margin: 0 auto;
    max-width: 1536px;
  }

  div {
    -webkit-overflow-scrolling: touch;
  }

  ul {
    b {
      font-weight: 500;
    }
  }

  h2 {
    font-family: var(--title-font-family);
    font-weight: 700;
    font-size: 1.7rem;

    @media (max-width: 600px) {
      font-size: 1.5rem;
    }
  }

  h3 {
    font-weight: 700;
    font-family: var(--title-font-family);
    font-size: 1.3rem;
  }

  button {
    font-family: var(--title-font-family);
    font-weight: 700;
  }

  [ant-click-animating-without-extra-node="true"]:after {
    border-color: transparent !important;
  }

  a {
    color: var(--primary-color);

    &:hover {
      color: var(--primary-color-light);
    }

    &.active:before {
      display: none;
    }

    &:visited {
      color: #7a008e;
    }
  }

  ul {
    padding: 0;
    margin: 0;
  }

  .list-item-hover .pdf-icon-container {
    background-color: var(--secondary-color);
  }

  .ant-btn-danger {
    color: #D7282F !important;
    border-color: #D7282F !important;
  }

  @media (max-width: 639px) {
    .search-description {
      display: none !important;
    }
    .global-navbar-advanced {
      width: 100% !important;
      span {
        white-space: normal !important;
      }
      input[type=text] {
        width: 100% !important;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
      }
      .justify-center {
        padding-bottom: 8px !important;
      }
      .ant-select-selection {
        border-bottom: 1px solid #d9d9d9 !important;
      }
      .ant-select-enabled {
        width: 100% !important;
      }
      #exact-filter {
        display: inline-block !important;
      }
      .anticon-right {
        display: none;
      }
    }
    .global-navbar-advanced-popover {
      width: 100% !important;
    }
    .container-nav-bar-filters {
      overflow-x: scroll !important;
    }
    .clear-right-filters {
      display: none;
    }
  }
`;
